module.exports = __webpack_public_path__ + "img/logo-netflix.86487615.svg";